const accessFarm = {

    FARM_LIST: {
        path: '/farm-list'
    },

    FARM_CROP_DETAILS: {
        path: '/farm-crop-details'
    },
    FARM_CROP_SCHEDULE: {
        path: '/farm-daily-schedule'
    },
    COMPLETE_FARM_DAILY_SCHEDULE: {
        path: '/complete-farm-daily-schedule'
    },

    DAILY_LOGS: {
        path: '/daily-logs'
    },
    DAILY_LOG_DETAILS: {
        path: '/daily-log-details'
    },
    ADD_DAILY_LOG: {
        path: '/add-daily-logs'
    },

    SERVICE_REQUEST_LIST: {
        path: '/service-request-list'
    },

    FARM_EXPENSE_LIST: {
        path: '/farm-expense-list'
    },

}

export default accessFarm;